const routeHelpers = {
    getLoanId() {
        let sessionLoanId = sessionStorage.getItem('selectedloan');

        const params = new Proxy(new URLSearchParams(window.location.search), {
            get: (searchParams, prop) => searchParams.get(prop),
        });

        let loanIdParam = params.id;

        let loanId;

        if (loanIdParam) {
            loanId = loanIdParam;
            sessionStorage.setItem('selectedloan', loanIdParam);
        } else {
            if (sessionLoanId) {
                loanId = sessionLoanId;
            }
        }

        return loanId;
    }
}

export default routeHelpers;